import PageLoadPercent from '@jumbo/components/PageComponents/PageLoadPercent';
import { UPDATE_PERCENT_DOWNLOAD, UPDATE_STATUS_DOWNLOAD } from '@jumbo/constants/ActionTypes';
import { EventName } from '@jumbo/constants/electron/EventName';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cleanListen } from 'redux/actions/Accounts';
const { ipcRenderer } = window.require('electron');

function InitEventDownload({ children }) {
    const { download, percent } = useSelector(({ common }) => common);
    const dispatch = useDispatch();

    useEffect(() => {
        ipcRenderer.send(EventName.Upgrade);
    }, []);

    useEffect(() => {
        ipcRenderer.on(EventName.Upgrade, (event, { status }) => {
            dispatch({
                type: UPDATE_STATUS_DOWNLOAD,
                payload: true,
            });
        });

        ipcRenderer.on(EventName.percentUpgrade, (event, { percentUpgrade }) => {
            dispatch({
                type: UPDATE_PERCENT_DOWNLOAD,
                payload: percentUpgrade,
            });
        });

        return () => {
            dispatch(cleanListen(EventName.Upgrade));
            dispatch(cleanListen(EventName.percentUpgrade));
        };
    }, [dispatch]);

    useEffect(()=>{
        if(download){
            document.querySelector("#download-app").setAttribute("style", "")
        }
    },[download])
    return (
        <React.Fragment>
            {children}
            <div id='download-app' style={{display : "none"}}>
                <PageLoadPercent value={percent} />
            </div>
        </React.Fragment>
    );
}

export default InitEventDownload;
